import Constants from "./constants";

// styles
var styles = {
  bannerImage: {
    fontSize: 45,
    marginTop: -7,
    height: '100%',
    fontWeight: 400,
  }, 
  chase: {
    color: Constants.colors.red,
    fontWeight: 400,
  },
};

var Navbar = [
  {
    id: "",
    of:
      <div style={styles.bannerImage}><span style={styles.chase}>chase</span>morrin</div>,
  },
  {
    id: "Calendar",
    of: "Calendar",
  },
  {
    id: "Bio",
    of: "About Chase",
  },
  {
    id: "Recordings",
    of: "Recordings",
  },
  {
    id: "Composing",
    of: "Composing",
  },
  {
    id: "Contact",
    of: "Follow/Contact",
  },
];

export default Navbar;